var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophoneOffSolid = function SvgMicrophoneOffSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.707 1.293a1 1 0 0 0-1.414 1.414L8 9.414V12a4 4 0 0 0 6.032 3.446l1.444 1.445A6 6 0 0 1 6 12V9.999a1 1 0 1 0-2 0v2a8.001 8.001 0 0 0 7 7.938V21H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-1.062a7.96 7.96 0 0 0 3.906-1.618l4.387 4.387a1 1 0 0 0 1.414-1.414l-4.387-4.387A7.965 7.965 0 0 0 20 12v-2a1 1 0 1 0-2 0v2c0 1.296-.41 2.496-1.11 3.476l-4.735-4.736-9.448-9.447Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.757V5a4 4 0 0 0-7.85-1.092l7.85 7.85Z",
    fill: "currentcolor"
  })));
};
export default SvgMicrophoneOffSolid;